import { getCurrentUser as amplifyGetCurrentUser, fetchUserAttributes as amplifyFetchUserAttributes } from 'aws-amplify/auth';

export const getCurrentUser = async () => {
  try {
    return await amplifyGetCurrentUser();
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
};

export const fetchUserAttributes = async () => {
  try {
    return await amplifyFetchUserAttributes();
  } catch (error) {
    console.error('Error fetching user attributes:', error);
    return {};
  }
};
